<template>
  <div class="review-container">
    <div class="top-bar">
      <!-- <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pbl/PBLLOGO.png" alt=""> -->
      <div class="back font-d2" @click="goback">
      <img src="https://cdn.spbcn.org/spbcnapp/2025ui/icon-back.png" alt="">
      返回
      </div>
      <div v-if="isMobile">
        <div class="tit1 font-h1">2026全球青少年PBL创新素养挑战赛</div>
        <div class="tit1 font-h1">评分系统</div>
      </div>
      <div v-if="!isMobile" class="tit3 font-h1">2026全球青少年PBL创新素养挑战赛评分系统</div>
      <img v-if="!isMobile" class="rt-logo" src="https://cdn.spbcn.org/spbcnWeb/pbl/PBLLOGO.png" alt="">

    </div>
    <div class="container">
      <div class="page-title">
        <img src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png" alt="">
        <span class="font-h2">基础信息</span>
      </div>
      <div class="font-d2 box mt-40">
        <div class="tit">
          <div class="key font-d2">项目名称</div>
          <div class="val font-d2">{{ teamInfo.name }}</div>
        </div>
        <div class="table">
          <el-row :gutter="10">
            <el-col :span="isMobile ? 24 : 6">
              <div class="tr">
                <div class="key">项目方向</div>
                <div class="val">{{ teamInfo.theme }}</div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">队伍名称</div>
                <div class="val">{{ teamInfo.teamName }}</div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">参赛学校</div>
                <div class="val" v-if="teamInfo.school">{{ teamInfo.school.schoolName }}</div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">指导老师</div>
                <div class="val">
                  <span class="stu" v-for="(teacher, i) in teamInfo.teachers" :key="i">{{teacher.userName}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">队伍成员</div>
                <div class="val">
                  <span class="stu" v-for="(stu, i) in teamInfo.students" :key="i">{{stu.userName}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">评委姓名</div>
                <div class="val" v-if="judgeInfo">{{ judgeInfo.userName }}</div>
              </div>
            </el-col>
            <el-col :span="isMobile ? 12 : 6">
              <div class="tr">
                <div class="key">评审日期</div>
                <div class="val">{{ today }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="page-title">
        <img src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png" alt="">
        <span class="font-h2">参赛资料<span class="font-d3">（建议使用PC端浏览器下载后预览）</span></span>
      </div>
      <el-row :gutter="20">
        <el-col :span="isMobile ? 12 : 6" v-for="(file, index) in fileList" :key="index">
          <div class="box mt-40" @click="downLoadFn(file.fileUrl)">
            <div class="tit tit2">
              <div class="val font-d2">{{ file.cn }}</div>
              <!-- <div class="key font-d2">{{ file.fileName }} -->
                <img src="../../../assets/images/download.png" alt="">
              <!-- </div> -->
            </div>
            <div class="desc font-d2">{{ file.desc }}</div>
          </div>
        </el-col>
      </el-row>
      <div class="tips font-d3" style="color: #999;margin-bottom: 80px;" v-if="!fileList.length">暂未上传参赛资料</div>
      <div class="tips font-d3">评审计分规则：<br v-if="isMobile"/>最终得分 = 过程性评价得分×40% + 终结性评价得分×60%，总分100分</div>
      <div class="page-title">
        <img src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png" alt="">
        <span class="font-h2">PBL{{ evalLabel }}评分标准<span class="font-d3">（总分100分，占总成绩{{ ratioPercent }}%）</span></span>
      </div>
      <div class="flex">
        <div class="total-score-item">
          <div class="font-d3">{{ evalLabel }}分数合计</div>
          <div class="score">{{ totalScore }}</div>
        </div>
        <div class="total-score-item">
          <div class="font-d3">{{ evalLabel }}折算总分</div>
          <div class="score">{{ convertScore }}</div>
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="isMobile ? 24 : 8" v-for="(item, index) in enumList" :key="index">
          <div class="box">
            <div class="tit">
              <div class="key font-d2">评价维度</div>
              <div class="val font-d2">{{ item.name }}</div>
            </div>
            <div class="w-card">
              <div class="flex-2">
                <div class="lf-item">
                  <div class="key font-d3">单项满分</div>
                  <div class="val font-d2">{{ item.maxScore }}分</div>
                </div>
                <div class="lf-item">
                  <div class="key font-d3">权重占比</div>
                  <div class="val font-d2">{{ formatWeight(item.weight) }}%</div>
                </div>
                <div class="input-item flex-1">
                  <div class="input-item-key font-d3">评委打分</div>
                  <div class="input-item-val font-d2">
                    <input :disabled="processSaved"
                      class="plain-input font-d2"
                      type="number"
                      min="0"
                      :max="item.maxScore"
                      v-model.number="item.score"
                      @blur="checkScore(item)"
                    >
                  </div>
                </div>
              </div>
              <div class="input-item flex-1 mt-40">
                <div class="input-item-key font-d3">评委点评</div>
                <div class="input-item-val font-d2 textarea">
                  <textarea :disabled="processSaved"
                    class="plain-textarea font-d2"
                    placeholder="请输入评委点评"
                    v-model="item.review"
                  ></textarea>
                </div>
              </div>
              <div class="submit-btn" v-if="!processSaved">
                <div class="btn font-d2" @click="saveFn(item)">暂存评分</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="sub-btn font-d2" @click="submitFn" v-if="!processSaved">提 交</div>
      <div class="sub-tip font-d3" v-if="!processSaved">提交后不可修改，请确认各项评分与点评均已填写并暂存</div>
      <div class="sub-tip font-d3" v-if="processSaved">过程性评价已点评</div>

    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      isMobile: false,
      type: this.$route.query.type,
      code: this.$route.query.code,
      pblTeamId: this.$route.query.pblTeamId,
      enumList: [], // 评价维度
      teamInfo: {},
      judgeInfo: {},
      today: '',
      fileList: [],
      processSaved: false, // 过程性评价已保存
      summativeSaved: false, // 终结性评价已保存
      review: '' // 整体点评：可选，没有内容时提交接口不传该字段
    }
  },
  created () {
    this.checkDevice()
    this.today = this.$moment(new Date()).format('YYYY年MM月DD日') // 评审日期：年月日
    document.title = 'GYPIC 评分系统'
    this.getTemplate()
  },
  computed: {
    // 评价类型文案：过程性评价 / 终结性评价
    evalLabel () {
      return this.type === 'summative' ? '终结性评价' : '过程性评价'
    },
    // 折算比例：过程性评价占总成绩40%、终结性评价占60%
    convertRatio () {
      return this.type === 'summative' ? 0.6 : 0.4
    },
    // 折算比例的百分数（文案展示用，写死整数避免浮点误差）
    ratioPercent () {
      return this.type === 'summative' ? 60 : 40
    },
    // 分数合计 = 各评价维度打分求和（原始分，满分100）
    totalScore () {
      return this.toRound(this.enumList.reduce((sum, item) => sum + this.toNumber(item.score), 0))
    },
    // 折算总分 = 分数合计 × 折算比例
    convertScore () {
      return this.toRound(this.totalScore * this.convertRatio)
    }
  },
  methods: {
    // 数值转换：空值/非法值按 0 计
    toNumber (val) {
      const n = Number(val)
      return isNaN(n) ? 0 : n
    },
    // 保留最多两位小数，去掉多余的 0（避免 34.800000000000004 这类浮点误差）
    toRound (val) {
      return Number((Number(val) || 0).toFixed(2))
    },
    // 权重占比：后端返回小数比例（0.2 → 20%）
    formatWeight (weight) {
      return parseInt(weight * 100)
    },
    // 判断打开窗口是手机端还是 PC 端（结果存入 this.isMobile，同时返回布尔值）
    checkDevice () {
      const ua = navigator.userAgent
      // 常见移动端 UA 关键字
      const isMobileUa = /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
      // iPadOS 13+ 默认以桌面 Safari UA 访问，UA 里没有 iPad，用「Mac 平台 + 多点触控」兜底识别
      const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      this.isMobile = isMobileUa || isIpadOs
      return this.isMobile
    },
    goback () {
      this.$router.back()
    },
    getTemplate () {
      this.$http.get(`common/pblJudge/${this.type}EvaluationEnumList`, { params: { judgeCode: this.code, pblTeamId: this.pblTeamId } }).then(res => {
        if (res.code === 200) {
          // 列表循环：每一项都要有独立的 score / review 字段，保证输入内容互不干扰且响应式
          this.enumList = (res.data.enumList || []).map(item => ({
            ...item,
            score: item.score === undefined || item.score === null ? '' : item.score,
            review: item.review || ''
          }))
          this.judgeInfo = res.data.pblJudge
          this.teamInfo = res.data.pblTeamVo
          this.fileList = res.data.pblTeamVo.file ? JSON.parse(res.data.pblTeamVo.file) : []
          this.processSaved = res.data.pblTeamJudgeTotalScore && (res.data.pblTeamJudgeTotalScore.processScore || res.data.pblTeamJudgeTotalScore.processScore === 0)
          this.summativeSaved = res.data.pblTeamJudgeTotalScore && (res.data.pblTeamJudgeTotalScore.summativeScore || res.data.pblTeamJudgeTotalScore.summativeScore === 0)
        }
      })
    },
    downLoadFn (url) {
      window.open(url)
    },
    // 打分失焦校验：超过单项满分则提示并清空该项打分
    checkScore (item) {
      const score = item.score
      if (score === '' || score === null || score === undefined) return
      const scoreNum = Number(score)
      if (isNaN(scoreNum)) return
      if (scoreNum > Number(item.maxScore)) {
        this.$message.warning('不可超过单项满分')
        item.score = ''
      }
    },
    // 保存单个评价维度的打分与点评
    saveFn (item) {
      const score = item.score
      if (score === '' || score === null || score === undefined) {
        this.$message.warning('请输入评委打分')
        return
      }
      if (!item.review || !String(item.review).trim()) {
        this.$message.warning('请输入评委点评')
        return
      }
      const scoreNum = Number(score)
      if (isNaN(scoreNum) || scoreNum < 0 || scoreNum > Number(item.maxScore)) {
        this.$message.warning(`评委打分需为0-${item.maxScore}之间的数字`)
        return
      }
      this.$http.post('common/pblJudge/processEvaluation', {
        flag: item.enumkey,
        judgeCode: this.code,
        pblTeamId: this.pblTeamId,
        review: item.review,
        score: scoreNum,
        type: this.type
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
        }
      })
    },
    // 一键提交：确认后结束本次评价
    submitFn () {
      this.$confirm('是否确认提交本次评分？提交后不可修改', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          code: this.code,
          pblTeamId: this.pblTeamId,
          type: this.type
        }
        // review 为可选项：没有内容时不传该字段
        if (this.review !== undefined && this.review !== null && String(this.review).trim() !== '') {
          params.review = this.review
        }
        return this.$http.post('common/pblJudge/evaluationEnd', params).then(res => {
          if (res.code === 200) {
            this.$message.success('提交成功')
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.review-container{
  background-color: #EAEAEA;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
/**字号集中处理 */
.font-h1{
  font-size: 52px;
  line-height: 52px;
}
.font-h2{
  font-size: 60px;
}
.font-d1{
  font-size: 30px;
}
.font-d2{
  font-size: 48px;
}
.font-d3{
  font-size: 38px;
}

.top-bar{
  width: 100vw;
  height: 220px;
  background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/top-bg.png);
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}
.tit1{
  color: #fff;
  font-family: systh;
  margin-bottom: 20px;
  text-align: right;
}
.container{
  padding: 20px 40px;
}
.tips{
  color: #666;
  font-family: systh;
  text-align: center;
  margin: 40px 0;
}
.page-title{
  display: flex;
  align-items: center;
  margin: 40px 0;
  img{
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  span{
    color: #C92739;
    font-family: systh;
  }
}
.key{
  color: #999999;
}
.val{
  font-family: systh;
}
.stu{
  margin-right: 20px;
  &:not(:last-child)::after{
    content: ',';
  }
}
.red{
  color: #C92739;
}
.back{
  color: #fff;
  font-family: alim;
  display: flex;
  align-items: center;
  cursor: pointer;
  img{
    width: 60px;
    height: auto;
    margin-right: 16px;
  }
}
.flex{
  display: flex;
  align-items: center;
}
.total-score-item{
  background-color: #C92739;
  color: #FFF;
  flex: 1;
  box-sizing: border-box;
  padding-left: 30px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: systh;
  margin: 60px 20px;
  .score{
    font-size: 62px;
    color: #C92739;
    background-color: #fff;
    width: 200px;
    height: 100px;
    text-align: center;
    line-height: 96px;
    margin: 2px 2px 2px 40px;
    border-radius: 20px;
  }
}

.table{
  background-color: #fff;
  margin-top: 60px;
  padding: 0 20px 20px;
  border-radius: 0 0 20px 20px;
  .tr{
    border: 1px solid #ebebeb;
    border-radius: 20px;
    margin: 20px 0;
    // display: flex;
    // align-items: flex-start;
    padding: 20px 40px;
    .key{
      // width: 200px;
      margin-bottom: 4px;
    }
    .val{
      flex: 1;
    }
  }
}

.box{
  background-color: #fff;
  border-radius: 20px;
  // margin-bottom: 40px;
  .tit{
    background-color: #C9273A;
    border-radius: 16px 16px 0 0;
    color: #fff;
    padding: 30px 40px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .key{
      color: #FD8E86;
      margin-right: 20px;
    }
  }
  .tit2{
    justify-content: space-between;
    // .key{
    //   text-decoration: underline;
      img{
        width: 60px;
        height: 60px;
      }
    // }
  }
  .desc{
    padding: 20px 40px;
    color: #666;
    font-family: systm;
    height: 340px;
  }
}
.w-card{
  padding: 30px;
  margin-bottom: 40px;
}
.flex-2{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lf-item{
  border: 2px solid #EBEBEB;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30%;
  height: 120px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.flex-1{
  flex: 1;
}
.input-item{
  background-color: #EAEAEA;
  display: flex;
  align-items: center;
  border-radius: 20px;
  .input-item-key{
    margin: 0 20px;
    text-align: center;
    font-family: systh;
  }
  .input-item-val{
    background-color: #fff;
    flex: 1;
    height: 100px;
    margin: 2px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
    &.textarea{
      height: 220px;
      align-items: stretch;
    }
    // 输入框本身不带样式，仅撑满外层白底
    .plain-input{
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: transparent;
      box-sizing: border-box;
      padding: 0 30px;
      font-family: inherit;
      font-size: inherit;
      color: inherit;
      &::placeholder{
        color: #bbb;
        font-family: systm;
      }
    }
    .plain-textarea{
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: transparent;
      box-sizing: border-box;
      padding: 20px 30px;
      resize: none;
      font-family: inherit;
      font-size: inherit;
      color: inherit;
      line-height: 1.4;
      &::placeholder{
        color: #bbb;
        font-family: systm;
      }
    }
  }
}
.mt-40{
  margin-top: 40px;
}

.submit-btn{
  margin: 30px;
  .btn{
    color: #C92739;
    background-color: #fff;
    border: 1px solid #C92739;
    cursor: pointer;
    width: 280px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-family: systh;
    margin: 60px auto 0;
    border-radius: 20px;
  }
}
// 一键提交大按钮：红色背景，比「暂存评分」稍大
.sub-btn{
  color: #fff;
  background-color: #C92739;
  cursor: pointer;
  width: 600px;
  height: 120px;
  text-align: center;
  line-height: 120px;
  font-family: systh;
  border-radius: 24px;
  margin: 80px auto 0;
  user-select: none;
  &:active{
    opacity: .85;
  }
}
.sub-tip{
  color: #999;
  text-align: center;
  margin: 20px 0 40px;
}

@media (min-width: 768px) {
  .font-h1{
    font-size: 18px;
  }
  .font-h2{
    font-size: 20px;
  }
  .font-d1{
    font-size:12px;
  }
  .font-d2{
    font-size: 14px;
  }
  .font-d3{
    font-size: 12px;
  }
  .top-bar{
    height: 60px;
    // padding-top: 12px;
    .logo{
      height: 80px;
    }
  }
  .container{
    padding: 10px 30px;
  }
  .mt-40{
    margin-top: 20px;
  }
  .back{
    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .page-title{
    margin: 10px 0;
    img{
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    span{
    }
  }
  .table{
    margin-top: 20px;
    .tr{
      min-height: 50px;
      margin: 10px 0;
      padding: 10px 20px;
      border-radius: 10px;
    }
  }
  .tit1{
    margin: 20px auto;
  }
  .box{
    border-radius: 14px;
    margin-bottom: 20px;
    .tit{
      border-radius: 10px 10px 0 0;
      padding: 10px 20px;
      margin-bottom: 10px;
    }
    .tit2{
      img{
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
    .desc{
      padding: 10px 20px;
      height: 80px;
    }
  }
  .tit3{
    color: #FFF;
    font-family: systh;
  }
  .rt-logo{
    height: 30px;
  }
  .input-item{
    .input-item-val{
      .plain-input{
        padding: 0 12px;
      }
      .plain-textarea{
        padding: 8px 12px;
      }
    }
  }

  .tips{
    margin: 20px 0;
  }

  .total-score-item{
    margin: 20px;
    border-radius: 10px;
    .score{
      width: 400px;
      height: 40px;
      line-height: 36px;
      border-radius: 10px;
      font-size: 22px;
    }
  }
  .w-card{
    padding: 10px 20px;
    margin-bottom: 14px;
  }
  .lf-item{
    border-radius: 10px;
    height: 40px;
    padding: 0 10px;
    margin-right: 14px;
  }
  .input-item {
    border-radius: 10px;
    .input-item-key{
      margin: 0 10px;
    }
    .input-item-val{
      height: 36px;
      border-radius: 10px;
      &.textarea{
        height: 80px;
      }
    }
  }
  .submit-btn{
    margin: 10px;
    .btn{
      width: 140px;
      height: 32px;
      line-height: 32px;
      margin: 20px auto 0;
      border-radius: 6px;
    }
  }
  // 一键提交大按钮：红色背景，比「暂存评分」稍大
  .sub-btn{
    width: 200px;
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    margin: 20px auto 0;
  }
  .sub-tip{
    margin: 10px 0 20px;
  }
}
</style>
